import React from 'react';
import { 
  Container, 
  Grid, 
  Box, 
  Skeleton, 
  IconButton,
  Button 
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const CrossingTradesSkeleton = () => {
  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* Left side - Title and Filters */}
            <div
              style={{
                width: "44%",
              }}
            >
              <Box
                sx={{
                  marginBottom: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* Title */}
                <Skeleton
                  variant="text"
                  width={150}
                  height={32}
                  sx={{ fontSize: "20px" }}
                />
                
                {/* Fund Select Dropdown */}
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={32}
                  sx={{ borderRadius: 1 }}
                />
              </Box>

              {/* Filter Options */}
              <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center" }}>
                {/* Crossing Custodian & Broker Button */}
                <Skeleton
                  variant="rectangular"
                  width={200}
                  height={32}
                  sx={{ borderRadius: 1 }}
                />
                
                {/* Real Custodian / Crossing Broker Button */}
                <Skeleton
                  variant="rectangular"
                  width={220}
                  height={32}
                  sx={{ borderRadius: 1 }}
                />
                
              
              
              </Box>
                {/* Toggle Switch */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Skeleton
                    variant="rectangular"
                    width={40}
                    height={20}
                    sx={{ borderRadius: 10 }}
                  />
                  <Skeleton variant="text" width={180} height={20} />
                </Box>
            </div>

            {/* Right side - Context Menu and Next Button */}
            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {/* Context Menu Button */}
              <IconButton
                sx={{
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #e0e0e0",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                <MoreVertIcon />
              </IconButton>
              
              {/* Next Button */}
              <Skeleton
                variant="rectangular"
                width={150}
                height={40}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </div>
        </Grid>

        {/* Table Section */}
        <Grid item xs={12}>
          <div
            aspectRatio={1}
            style={{
              display: "flex",
              flexDirection: "row",
              width: "45%",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ width: "100%" }}>
              {/* Table Container with Border */}
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: 2,
                  backgroundColor: "transparent",
                }}
              >
                {/* Table Header */}
                <Box sx={{ display: "flex", mb: 2, borderBottom: "1px solid #ccc", pb: 1 }}>
                  <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={100} height={24} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={100} height={24} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width={60} height={24} />
                </Box>

                {/* Table Rows - Multiple rows to show scrollable content */}
                {Array.from({ length: 20}).map((_, index) => (
                  <Box 
                    key={index} 
                    sx={{ 
                      display: "flex", 
                      mb: 1, 
                      py: 0.5,
                      borderBottom: index < 19 ? "1px solid #ccc" : "none",
                      backgroundColor: "transparent",
                    }}
                  >
                    <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
                    <Skeleton variant="text" width={100} height={16} sx={{ mr: 2 }} />
                    <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
                    <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
                    <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
                    <Skeleton variant="text" width={100} height={16} sx={{ mr: 2 }} />
                    <Skeleton variant="text" width={60} height={16} />
                  </Box>
                ))}
              </Box>
            </Box>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CrossingTradesSkeleton; 